export default {
    /**
     * 
     * @param {*} params 
     * @returns promise
     * Return list of user notifications
     */
     getNotifications(params){
        return new Promise((resolve, reject) => {
            ApiClient.get(`/notifications`, params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
        
    },

    /**
     * 
     * @param {int} idNotification 
     * @returns Promise
     * Mark a notification as read
     */
     markAsRead(idNotification){
        return new Promise((resolve, reject) => {
            ApiClient.patch(`/notifications/${idNotification}/mark-as-read`, {}, {read: true})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })   
    },
    /**
     * 
     * @param {int} idNotification 
     * @returns Promise
     * Mark a notification as unread
     */
     markAsUnRead(idNotification){
        return new Promise((resolve, reject) => {
            ApiClient.patch(`/notifications/${idNotification}/mark-as-read`, {}, {read: false})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })   
    },

    /**
     * 
     * @param {int} idNotification 
     * @returns Promise
     * Delete notification
     */
     delete(idNotification){
        return new Promise((resolve, reject) => {
            ApiClient.del(`/notifications/${idNotification}`, {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
        
    },

    /**
     * 
     * @param {int} idNotification 
     * @returns Promise
     * Delete notification
     */
     getUnreadNotifications(){
        return new Promise((resolve, reject) => {
            ApiClient.post(`/notifications/search`, { limit: 0 }, {filters: {"is_read" : false}})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
        
    },

    /**
     * 
     * @returns Promise
     * Mark all user notifications as read
     */
     markAllAsRead(){
        return new Promise((resolve, reject) => {
            ApiClient.patch(`/notifications/mark-all-as-read`, {}, {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })   
    },


}